<template>
  <b-dropdown position="is-bottom-left" v-model="$i18n.locale" aria-role="list">
    <template #trigger>
      <b-button
        class="pt-5 pb-5"
        size="is-small"
        type="is-white"
        pack="fas"
        icon-right="caret-down"
      >
        <country-flag
          style="vertical-align: middle"
          :country="country"
          size="small"
        />
        <span class="ml-1">{{ languageShortCode }}</span>
      </b-button>
    </template>

    <b-dropdown-item
      :key="index"
      v-for="(lang, index) in langsList"
      :value="lang"
      aria-role="listitem"
    >
      <div class="media columns is-vcentered">
        <country-flag
          :country="lang.slice(-2).toLowerCase()"
          size="normal"
          rounded
        />
        <div class="media-content">
          <h3>{{ $t("Register.OTHER.LANGS." + lang) }}</h3>
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import * as moment from "moment";
import UtilsMixin from "../mixins/UtilsMixin.js";

export default {
  name: "Header",
  mixins: [UtilsMixin],
  components: {},

  data() {
    return {
      isLang: 1,
    };
  },

  watch: {
    locale: function () {
      moment.locale(this.locale);
      console.log("Change langage into : ", this.locale);
    },
  },
};
</script>
